import { MutationKey } from '@shared/config';
import { useMutation } from '@tanstack/react-query';
import { vacancyApi } from '../vacancyApi';

export const useGetVacancyCopy = () =>
  useMutation({
    mutationKey: [MutationKey.CREATE_VACANCY_COPY],
    mutationFn: (id: number) => vacancyApi.getVacancy({ id }),
  });
